import { render, staticRenderFns } from "./RTypeDetectionTrend.vue?vue&type=template&id=6c242b0e&scoped=true&"
import script from "./RTypeDetectionTrend.vue?vue&type=script&lang=js&"
export * from "./RTypeDetectionTrend.vue?vue&type=script&lang=js&"
import style0 from "./RTypeDetectionTrend.vue?vue&type=style&index=0&id=6c242b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c242b0e",
  null
  
)

/* custom blocks */
import block0 from "./RTypeDetectionTrend.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c242b0e')) {
      api.createRecord('6c242b0e', component.options)
    } else {
      api.reload('6c242b0e', component.options)
    }
    module.hot.accept("./RTypeDetectionTrend.vue?vue&type=template&id=6c242b0e&scoped=true&", function () {
      api.rerender('6c242b0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/RTypeDetectionTrend/RTypeDetectionTrend.vue"
export default component.exports